import Vue from 'vue';
import { API } from 'aws-amplify';
import _ from 'lodash';

import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '../types';
import { AppState } from './types';

/**
 * Actions
 *
 * Actions are similar to mutations, the differences being that:
 * - Instead of mutating the state, actions commit mutations.
 * - Actions can contain arbitrary asynchronous operations.
 * - Actions are triggered with the store.dispatch method e.g. `store.dispatch('getSettings')`
 */
export const actions: ActionTree<AppState, RootState> = {

	/**
	 * Clear store
	 * 
	 * @param {AppState} store
	 */
	async resetAllStates(store: ActionContext<AppState, any>): Promise<void> {
		store.commit('resetState');
		store.commit('auth/resetState', null, { root: true });
		store.commit('customers/resetState', null, { root: true });
		store.commit('maintenancejobs/resetState', null, { root: true });
		store.commit('properties/resetState', null, { root: true });
		store.commit('contractors/resetState', null, { root: true });
		store.commit('sysadmin/resetState', null, { root: true });
	}
};
